module.exports = __webpack_public_path__ + "img/dep_clothingandaccessories@3x.3615eb15.png";